import React from 'react';
import Step from './Step';
import Login from '../hooks/useLogin';
import BmiCookieConsent from './BmiCookieConsent';
import { CreateDotaznik } from '../hooks/createDotaznik';
import stepsJson from '../assets/steps.json';
import dotaznikJson from '../assets/dotaznik.json';
import BG_IMG_CLOUDS from "../assets/img/bg_img_clouds.png";
import BG_IMG_PLANE from "../assets/img/bg_img_plane.png";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBSwitch,
    MDBBtn,
    MDBValidationItem,
    MDBAccordion,
    MDBAccordionItem,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';



const CONSTANTS = {
    LINK_CENIK: "https://www.bmicz.cz/cenik-bramac/",
    LINK_OBLASTNI_ZASTUPCE: "https://www.bmigroup.com/cz/bmi-bramac/kontakty/obchodni-zastupci-bmi-bramac",
    FIRST_PAGE_SWITCH_TEXT_CLASSES: "d-grid align-items-end px-3 mb-4 mt-3 user-select-none pointer switch-text",
}



class PriceCalculatorForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            files: [],
            dotaznik: dotaznikJson,
            dotaznikValid: false,
            dotaznikCreated: false,

            roofCalculation: true,
            isolation: false,
            documentation: false,
            noDocumentation: false,
            buildingExists: false,
            extensions: false,
            gdprConsent: false,

            steps: stepsJson,
            activeItems: [3, 7],
            activeStep: 1,

            noDocumentationModal: false,
            noBuildingModal: false,
            gdprModal: false,
            confirmationModal: false,
            loadingModal: false,
            loadingModalTitle: "Požadavek na výpočet se odesílá . . .",
            loadingModalText: "",

            config: {
                LINK_CENIK: CONSTANTS.LINK_CENIK,
                LINK_OBLASTNI_ZASTUPCE: CONSTANTS.LINK_OBLASTNI_ZASTUPCE,
            },
        };
        this.stateHandler = this.stateHandler.bind(this);
        // this.loginHandler = this.loginHandler.bind(this);
        this.dotaznikCreateHandler = this.dotaznikCreateHandler.bind(this);
    }

    componentDidMount() {
        fetch(process.env.PUBLIC_URL + '/config.json')
            .then(r => r.json())
            .then(config => this.setState({ config: { ...this.state.config, ...config } }))
            .catch(() => {});
    }

    handleDocumentation(e) {
        if (e.target.id === "HaveDocumentation" && e.target.checked) {
            if (this.state.noDocumentation) {
                document.getElementById('DontHaveDocumentation').click();
            }
        } else if (e.target.id === "DontHaveDocumentation" && e.target.checked) {
            if (this.state.documentation) {
                document.getElementById('HaveDocumentation').click();
            }
        } else if (e.target.id === "DontHaveDocumentation" && !e.target.checked) {
            this.setState({ buildingExists: false })
        }
        let stepContact = this.getStep(7);
        stepContact.showMap = this.state.noDocumentation;
    }

    stepsControl() {
        let stepsArray = this.state.steps;
        stepsArray.forEach(step => {
            if (step.state != "") {
                let value = this.state[step.state];
                step.visible = value;
            }
            if (step.number == 7) {
                step.showMap = this.state.noDocumentation;
            }
            step.visibleClass = (step.visible) ? "" : "d-none";
        })
    }

    stateHandler(name, value) {
        if (name === 'extensions') {
            this.setState({ ...this.state, [name]: value }, () => this.accordionHandler([3, 4]));
        } else if (name === 'isolation') {
            this.setState({ ...this.state, [name]: value });
        } else {
            this.setState({ ...this.state, [name]: value });
        }
    }

    toggleNoDocModal() {
        if (this.state.noDocumentation) {
            this.setState({ noDocumentationModal: !this.state.noDocumentationModal });
        }
    }

    toggleNoBuildingModal() {
        this.setState({ noBuildingModal: !this.state.noBuildingModal });
    }
    toggleConfirmationModal() {
        this.setState({ confirmationModal: !this.state.confirmationModal });
    }

    accordionHandler(id) {
        this.setState({ ...this.state, activeItems: id });
    }


    disableSendButton(setDisabled) {
        let sendButton = document.getElementById('sendFormBtn');
        if (sendButton) {
            (setDisabled) ? sendButton.setAttribute('disabled', true) : sendButton.removeAttribute('disabled');
        }
    }

    fillDotaznik() {
        this.disableSendButton(true);

        let step2 = this.getStep(2); // project doc
        let step3 = this.getStep(3); // coverings
        let extensions = this.getStep(4).data.values; // extensions
        let step5 = this.getStep(5); // gutters
        let step6 = this.getStep(6); // isolation
        let step7 = this.getStep(7); // contact form [objectPhoto for fileUpload]
        if (!this.state.extensions) extensions = {};

        var dotaznik = dotaznikJson;
        dotaznik.dokumentace = this.state.documentation
        dotaznik.datum = this.getCurrentDate();
        dotaznik.kontakt = step7.data.formData.kontakt;
        dotaznik.stavba = step7.data.formData.stavba;
        if (dotaznik.stavba.investor == "") {
            dotaznik.stavba.investor = dotaznik.kontakt.jmeno + " " + dotaznik.kontakt.prijmeni;
        }
        dotaznik.poznamka = step7.data.formData.stavba.poznamka;

        if (this.state.roofCalculation) {
            dotaznik.sortiment = {
                stdKrytina: step3.data.popularOnly,
                krytiny: step3.data.dotaznikCoverings,
                okapTyp: step5.data.chosenOkap.model,
                okapBarva: step5.data.chosenOkap.barva,
                rozsireni: {
                    protisnehovyHak: (extensions.item13) ? "A" : "N" || "N",
                    lemovani: (extensions.item9) ? "A" : "N" || "N",
                    hromosvod: (extensions.item10) ? "A" : "N" || "N",
                    okno: extensions.item1 || 0,
                    plosina40: extensions.item2 || 0,
                    // plosina80: extensions.item3 || 0,
                    kanalizace: extensions.item4 || 0,
                    sanita: extensions.item5 || 0,
                    antena: extensions.item6 || 0,
                    turbokotel: extensions.item7 || 0,
                    drzakAntena: extensions.item8 || 0,
                    luminex60: extensions.item12 || 0,
                }
            }
        }
        if (this.state.isolation) {
            dotaznik.izolace = { ...step6.data };
            dotaznik.izolace.izolaceTloustka = dotaznik.izolace.izolaceTyp + " " + dotaznik.izolace.izolaceTloustka;
            if (!dotaznik.izolace.rozpisPrvku) dotaznik.izolace.zatepleniPresahu = dotaznik.izolace.rozpisPrvku;
        }
        //console.log("dotaznik to send", dotaznik)

        // Files
        let docFiles = [];
        if (step2.data.files != null) {
            docFiles = docFiles.concat([...step2.data.files]);
            dotaznik.bramac.zdroj = '016';
        }
        if (step7.data.objectImage != undefined) {
            step7.data.objectImage[0].typ = 'GPS';
            docFiles = docFiles.concat([...step7.data.objectImage]);
        }
        
        // Set files, then create Dotaznik
        this.setState({ files: docFiles },
            () => this.setState({ dotaznikValid: true },
                () => this.setState({ loadingModal: true }))
        );

    }
    sendDotaznik() {
        return ((this.state.dotaznikValid) ?
            <CreateDotaznik state={this.state} handler={this.dotaznikCreateHandler} />
            : <div></div>
        )
    }

    //callback function after create dotaznik API
    dotaznikCreateHandler(isCreated, message, responseMessage) {
        if (isCreated) {
            this.setState({ dotaznikCreated: true },
                () => this.setState({ loadingModalTitle: "Požadavek na výpočet byl úspěšně odeslán" },
                    () => this.setState({ loadingModalText: "Počkejte prosím na přesměrování" })
                )
            );
            return;
        }
        this.disableSendButton(false);
        if (message === "notAuth" || (responseMessage.error !== undefined && responseMessage.error === "Unauthorized")) {
            this.showInvalid("ErrorCreate", "Nepovedlo se spojit se serverem");
        } else if (responseMessage !== undefined && responseMessage.slice(0, 18) === "Nelze přiřadit PSČ") {
            this.showInvalid("pscKontakt", "Chyba ve formuláři - neplatné PSČ odesílatele. Zadejte jiné nejbližší PSČ.");
        } else {
            this.showInvalid("ErrorCreate", "Nepovedlo se odeslat formulář");
        }

        this.setState({ dotaznikValid: false },
            () => this.setState({ loadingModal: false })
        );
    }

    getCurrentDate() {
        var currentdate = new Date();
        var datetime = currentdate.getFullYear() + '-'
            + (((currentdate.getMonth() + 1) < 10) ? "0" : "") + (currentdate.getMonth() + 1) + '-'
            + ((currentdate.getDate() < 10) ? "0" : "") + currentdate.getDate() + "T"
            + ((currentdate.getHours() < 10) ? "0" : "") + currentdate.getHours() + ":"
            + ((currentdate.getMinutes() < 10) ? "0" : "") + currentdate.getMinutes() + ":"
            + ((currentdate.getSeconds() < 10) ? "0" : "") + currentdate.getSeconds();
        return datetime;
    }



    validateAll() {
        // if dotaznik was already created by API then ignore validation
        if (this.state.dotaznikCreated) {
            this.showInvalid('alreadyCreated', 'Formulář už byl vytvořen, není potřeba ho znovu posílat');
            return;
        }

        // 1 or 2 switch, 3 or 4(ano/yes) switch
        if (!this.state.roofCalculation && !this.state.isolation) {
            this.showInvalid("RoofCalculation", "Vyberte alespoň jednu z možnosti kalkulace - střešní tašky a/nebo nadkrokevní izolace");
            return;
        }
        if (!this.state.documentation && !this.state.noDocumentation) {
            this.showInvalid("HaveDocumentation",
                "Vyberte jednu z možnosti dokumentace - buď máte projektovou dokumentaci, nebo si přejete zaměřit objekt");
            return;
        }

        // has documentation valid
        if (this.state.documentation) {
            let docStep = this.getStep(2);
            if (docStep.data.files == undefined || docStep.data.fileSize == 0) {
                this.showInvalid("documentationFiles", "Nahrajte soubory dokumentace");
                return;
            } else if (docStep.data.fileSize >= 20000000) {
                this.showInvalid("documentationFiles", "Moc velká velikost souborů, vyberte méně souborů");
                return;
            }
        }

        // selected coverings
        if (this.state.roofCalculation) {
            let coveringStep = this.getStep(3);
            if (coveringStep.data == undefined
                || coveringStep.data.dotaznikCoverings == undefined
                || coveringStep.data.dotaznikCoverings.length == 0) {
                this.setState(
                    { ...this.state, activeItems: [3] },
                    () => this.showInvalid("popularCovering", "Vyberte alespoň jeden model střešní krytiny")
                );
                return;
            }
        }

        // isolation type and width
        if (this.state.isolation) {
            let isolationStep = this.getStep(6);
            if (isolationStep.data.izolaceTyp == "" || isolationStep.data.izolaceTloustka == "" ||
                isolationStep.data.izolaceTloustka <= 0 ||
                isolationStep.data == undefined || Object.keys(isolationStep.data).length < 1) {
                this.setState(
                    { ...this.state, activeItems: [6] },
                    () => this.showInvalid("Basic", "Vyberte typ a tloušťku izolace")
                );
                return;
            }

            // 'Rozpis prvku' or 'Servisni posouzeni' atleast
            if (!isolationStep.data.rozpisPrvku && !isolationStep.data.servisniPosouzeniTepelneOchrany) {
                this.setState(
                    { ...this.state, activeItems: [6] },
                    () => this.showInvalid("rozpisPrvku", "Vyberte alespoň jednu z možností \n 'Rozpis prvků' nebo 'Servisní posouzení'")
                );
                return;
            }

            // isolation servis validation
            if (isolationStep.data.servisniPosouzeniTepelneOchrany == true) {
                if (isolationStep.data.osovaRoztecKrokvi == "") {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("roofCompPitch", "Zadejte hodnotu")
                    );
                    return;
                }
                if (isolationStep.data.sirkaKrokvi == "") {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("roofCompWidth", "Zadejte hodnotu")
                    );
                    return;
                }
                if (isolationStep.data.konstrukcniVrstvy.find(row => row.nazev != "") == undefined) {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("nazev", "Musí být vyplněny konstrukční vrstvy střechy")
                    );
                    return;
                }
            }
        }

        // contact form
        this.setState({ activeItems: [7] });

        // map address input
        if (this.state.noDocumentation) {
            let addressInput = document.querySelector('div#mapAutocompleteDiv .geocoder-container input');
            if (addressInput && (addressInput.value === undefined || addressInput.value === "")) {
                addressInput.setCustomValidity("Vyberte platnou adresu stavby");
                addressInput.reportValidity();
                addressInput.setCustomValidity("");
                return;
            } else {
                addressInput.setCustomValidity("");
            }
        }

        // whole contact form
        if (!document.getElementById("kontaktForm").reportValidity()) {
            this.showInvalid("kontaktFormMessage", "Správně vyplňte kontaktní formulář");
            return;
        }
        let stavbaData = this.getStep(7).data.formData.stavba;
        if (stavbaData.ulice == "" || stavbaData.obec == "" || stavbaData.psc == "") {
            this.showInvalid("buildingAddress",
                "Špatně zadaná adresa, vyberte platnou adresu stavby \n (vyberte stavbu na mapě)")
            return;
        }
        if (stavbaData.ulice.length > 200) {
            this.showInvalid("stavbaUlice",
                "Moc dlouhá adresa (" + stavbaData.ulice.length + " znaků). Zkraťte na 200 nebo napište adresu do poznámky.")
            return;
        }

        // gdpr consent
        if (!this.state.gdprConsent) {
            this.showInvalid("consentSwitch", "Pro odeslání musíte souhlasit se zpracováním osobních údajů")
            return;
        }

        this.fillDotaznik();
    }

    getStep(num) {
        return this.state.steps.find(step => step.number == num);
    }

    showInvalid(elementId, message) {
        let element = document.getElementById(elementId);
        if (element != undefined) {
            element.setCustomValidity(message);
            element.reportValidity();
            element.setCustomValidity("");
        }
        //else // Commented "else" == always show additional validationMesage
        {
            element = document.getElementById('validationMesage');
            let existingTextElement = document.getElementById('validationText')
            if (existingTextElement != undefined) {
                element.removeChild(existingTextElement);
            }
            let textElement = document.createElement('p');
            textElement.id = 'validationText';
            textElement.innerText = message;
            element.classList.remove('d-none');
            element.appendChild(textElement);
            setTimeout(() => {
                this.hideInvalid();
            }, 4500);
        }
    }
    hideInvalid() {
        let element = document.getElementById('validationMesage');
        element.classList.add('d-none');
        let validationText = document.getElementById('validationText')
        if (validationText) element.removeChild(validationText);
    }
    debugDiv() {
        return (process.env.REACT_APP_ENV === "dev" || process.env.REACT_APP_ENV === "localhost") ? (
            <div>
                React env - {process.env.NODE_ENV};
                Custom env - {process.env.REACT_APP_ENV};
                apiUrl - {process.env.REACT_APP_API_URL};
                (Toto je vidět pouze u testování)
            </div>
        ) : (<span></span>);
    }

    render() {
        this.stepsControl();
        const docUploadClass = (this.state.documentation) ? '' : 'd-none';

        return (
            <div className="App">
                <Login />
                {this.debugDiv()}

                <div key='InitialStep' className='mt-4 rootContainer m-auto'>
                    <MDBContainer>
                        <MDBRow>
                            <MDBCol size='12' md='8' lg='9' className=''>
                                <h2 className='text-uppercase c-primary'>Kalkulace střešní krytiny bramac</h2>
                            </MDBCol>
                            <MDBCol size='12' md='4' lg='3' className='d-flex justify-content-md-end'>
                                <MDBBtn color='link' rippleColor='light' size='lg' href={this.state.config.LINK_CENIK} className='text-decoration-underline c-primary px-0' target='_blank'>
                                    Ceník ke stažení
                                </MDBBtn>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>

                    <MDBContainer className='mb-5 planeBackground' style={{
                        backgroundImage: "url(" + BG_IMG_PLANE + "),url(" + BG_IMG_CLOUDS + ")"
                    }}>
                        <MDBRow>
                            <MDBCol size='6' className="mt-5">
                                <p>
                                    Chcete pomoci s vyplněním? Kontaktujte nás.
                                </p>
                                <MDBBtn color='link' rippleColor='light' size='lg' className='text-decoration-underline p-0 c-primary'
                                    href={this.state.config.LINK_OBLASTNI_ZASTUPCE} target='_blank'>
                                    Kontakt na obchodní zástupce
                                </MDBBtn>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-5">
                            <MDBRow className='mt-3 align-items-end'>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.roofCalculation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={(e) => { document.getElementById('RoofCalculation').click(); }}>
                                        Chci spočítat střechu
                                    </p>
                                    <MDBValidationItem className='' invalid feedback='Example invalid feedback text.'>
                                        <MDBSwitch id='RoofCalculation' name='roofCalculation'
                                            wrapperClass="d-grid justify-content-center" defaultChecked={this.state.roofCalculation}
                                            onClick={(e) => { this.setState({ roofCalculation: e.target.checked }) }} />
                                    </MDBValidationItem>
                                </MDBCol>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.isolation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={(e) => { document.getElementById('Isolation').click(); }}>
                                        Chci také rozpis prvků a&nbsp;posouzení nadkrokevní izolace bramactherm
                                    </p>
                                    <MDBSwitch id='Isolation' name='isolation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.isolation}
                                        onClick={(e) => {
                                            this.setState({ isolation: e.target.checked },
                                                this.accordionHandler(6))
                                        }} />
                                </MDBCol>
                            </MDBRow>

                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol xl="11" md='11' sm="12">
                                <p>
                                    Máte projektovou dokumentaci? Dokumentací se rozumí půdorys střechy
                                    nebo krovu se zakreslenými sklony (může být i náčrtek, nákres apod.), příp.
                                    řezy a pohledy. Nemáte dokumentaci? Nevadí, střechu si zaměříme sami
                                    pomocí leteckého snímkování Bramac Scan.
                                </p>
                            </MDBCol>
                            <MDBRow className='mt-3'>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.documentation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={() => { document.getElementById('HaveDocumentation').click(); }}>
                                        Mám projektovou dokumentaci
                                    </p>
                                    <MDBSwitch id='HaveDocumentation' name='documentation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.documentation}
                                        onClick={(e) => {
                                            this.setState(
                                                { documentation: e.target.checked },
                                                () => this.handleDocumentation(e))
                                        }} />
                                </MDBCol>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.noDocumentation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={() => { document.getElementById('DontHaveDocumentation').click(); }}>
                                        Nemám projektovou dokumentaci
                                    </p>
                                    <MDBSwitch id='DontHaveDocumentation' name='documentation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.noDocumentation}
                                        onClick={(e) => {
                                            this.setState({ noDocumentation: e.target.checked },
                                                () => {
                                                    this.toggleNoDocModal();
                                                    this.handleDocumentation(e);
                                                })
                                        }} />
                                </MDBCol>
                            </MDBRow>

                            <div key='NoDocumentationModals'>
                                <MDBModal staticBackdrop open={this.state.noDocumentationModal} tabIndex='-1'>
                                    <MDBModalDialog centered size='lg'>
                                        <MDBModalContent className='p-2'>
                                            <MDBModalHeader>
                                                <MDBModalTitle className='text-uppercase'>Zaměření střechy bez dokumentace</MDBModalTitle>
                                                {/*<MDBBtn className='btn-close' color='none' onClick={() => this.toggleNoDocModal()}></MDBBtn>*/}
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                                <p>Rozpis materiálu a cenovou nabídku provádíme na základě leteckých snímků, ze kterých provedeme zaměření střechy.</p>
                                                <p>
                                                    Kalkulaci bez doložení projektové dokumentace můžeme tedy provést
                                                    <b> pouze pro již existující objekty.</b>
                                                </p>
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                                <MDBBtn color='primary' className='mx-auto fs-6 px-5 no-doc-modal-btn' onClick={() => this.setState({ buildingExists: true }, this.toggleNoDocModal())}>
                                                    Ano, jedná se o již existující objekt
                                                </MDBBtn>
                                                <MDBBtn color='primary' className='mx-auto fs-6 px-5 no-doc-modal-btn' onClick={() => { this.toggleNoDocModal(); this.toggleNoBuildingModal(); }}>
                                                    Ne, objekt se teprve bude stavět
                                                </MDBBtn>
                                            </MDBModalFooter>
                                        </MDBModalContent>
                                    </MDBModalDialog>
                                </MDBModal>
                                <MDBModal staticBackdrop open={this.state.noBuildingModal} tabIndex='-1'>
                                    <MDBModalDialog centered>
                                        <MDBModalContent>
                                            <MDBModalHeader>
                                                <MDBModalTitle className='text-uppercase'>Pozor!</MDBModalTitle>
                                                <MDBBtn className='btn-close' color='none' onClick={() => {
                                                    this.toggleNoBuildingModal();
                                                    document.getElementById('DontHaveDocumentation').click();
                                                }}></MDBBtn>
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                                U neexistujicího objektu bez dokumentace nemůžeme spočítat kalkulaci střechy.
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                                <MDBBtn color='primary' className='mx-auto fs-6' onClick={() => {
                                                    this.toggleNoBuildingModal();
                                                    document.getElementById('DontHaveDocumentation').click();
                                                }}>
                                                    Rozumím
                                                </MDBBtn>
                                            </MDBModalFooter>
                                        </MDBModalContent>
                                    </MDBModalDialog>
                                </MDBModal>
                            </div>
                        </MDBRow>
                    </MDBContainer>

                    <MDBContainer className={docUploadClass}>
                        <Step key={"step2"} step={this.state.steps.find(step => step.number == 2)} handler={this.stepsHandler} />
                    </MDBContainer>

                    <MDBContainer>
                        <MDBAccordion flush alwaysOpen active={this.state.activeItems} onChange={(itemId) => this.accordionHandler(itemId)}>
                            {this.state.steps.map(step => {
                                return (step.accStep) ? (
                                    <MDBAccordionItem collapseId={step.number} headerTitle={step.header} key={'step' + step.number} className={step.visibleClass}>
                                        <MDBContainer>
                                            <Step step={step} handler={this.stepsHandler} stateHandler={this.stateHandler} />
                                        </MDBContainer>
                                    </MDBAccordionItem>
                                ) : (
                                    <div key={"nstep" + step.number}></div>
                                )

                            })}
                        </MDBAccordion>
                    </MDBContainer>

                    <MDBContainer className='mt-5 d-flex justify-content-center align-items-center'>
                        <MDBSwitch id='consentSwitch' name='consent'
                            onClick={(e) => { this.setState({ gdprConsent: e.target.checked }) }} />
                        <MDBBtn color='link' rippleColor='light' className='content-link ms-1 px-1' onClick={() => { this.setState({ gdprModal: true }) }}>
                            Souhlas se zpracováním osobních údajů a poučení subjektu údajů
                        </MDBBtn>

                        <MDBModal open={this.state.gdprModal} tabIndex='-1' onClose={() => this.setState({ gdprModal: false })}>
                            <MDBModalDialog scrollable size='xl'>
                                <MDBModalContent className='p-2'>
                                    <MDBModalHeader>
                                        <MDBModalTitle className='text-uppercase'>Zpracování osobních údajů a poučení subjektu údajů</MDBModalTitle>
                                        <MDBBtn className='btn-close' color='none' onClick={() => this.setState({ gdprModal: false })}></MDBBtn>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <Step step={this.state.steps.find(step => step.number == 8)} handler={this.stepsHandler} stateHandler={this.stateHandler} />
                                    </MDBModalBody>
                                    <MDBModalFooter>
                                        <MDBBtn color='primary' className='mx-auto fs-6' onClick={() => this.setState({ gdprModal: false })}>
                                            Rozumím
                                        </MDBBtn>
                                    </MDBModalFooter>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>
                    </MDBContainer>

                    <MDBContainer className="d-grid my-4 text-center">
                        <div id='validationMesage' className='validation-msg d-none fs-5' onClick={() => this.hideInvalid()}>
                            <MDBBtn className='btn-close float-end ms-3' color='none'></MDBBtn>
                        </div>
                        <button id='sendFormBtn' className="btn btn-primary btn-lg fs-5 fw-bold"
                            onClick={() => this.validateAll()} disabled={!this.state.gdprConsent}>
                            Odeslat &gt;&gt;
                        </button>
                        <MDBModal staticBackdrop open={this.state.loadingModal} tabIndex='-1' >
                            <MDBModalDialog centered>
                                <MDBModalContent className='p-2'>
                                    <MDBModalHeader>
                                        <MDBModalTitle className='text-uppercase'>{this.state.loadingModalTitle}</MDBModalTitle>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <p>{this.state.loadingModalText}</p>
                                    </MDBModalBody>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>
                    </MDBContainer>
                </div>
                {this.sendDotaznik()}

                <BmiCookieConsent />
            </div>
        );
    }
}

export default PriceCalculatorForm;


function primaryColorByBool(value) {
    return value ? ' c-primary ' : ' ';
}


